import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-402ebeb9")

_pushScopeId("data-v-402ebeb9")
const _hoisted_1 = { class: "backHeader" }
const _hoisted_2 = { class: "header flex justify-between align-items-center" }
const _hoisted_3 = { class: "ml8" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "right" }, null, -1)
const _hoisted_5 = { class: "body" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ArrowLeftOutlined = _resolveComponent("ArrowLeftOutlined")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "left pointer ml32",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
      }, [
        _createVNode(_component_ArrowLeftOutlined, { class: "icon" }),
        _createVNode("span", _hoisted_3, _toDisplayString(_ctx.backMsg), 1)
      ]),
      _hoisted_4
    ]),
    _createVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "body")
    ])
  ]))
})